import { TableRow, TableCell } from 'src/shared/components/ui/table'
import { useLocalization } from 'src/shared/hooks/useLocalization'

/** Marks a proposal alternative that is not part of the order total (staff view only). */
export const QuoteAlternativeLabelRow = ({
  slot,
  colSpan,
}: {
  slot: string
  colSpan: number
}) => {
  const { t } = useLocalization()
  return (
    <TableRow className="border-0 hover:bg-transparent">
      <TableCell
        colSpan={colSpan}
        className="border-0 px-4 pb-1 pt-0 text-xs text-muted-foreground"
      >
        {t(
          `Alternative for “${slot}” — not selected, not counted in the total`,
          `Alternativ för ”${slot}” — inte valt, räknas inte i totalen`
        )}
      </TableCell>
    </TableRow>
  )
}
